import $ from "jquery";
import { GooglePlaceDetails, makeAddressAutocomplete } from "./places";
import { GoogleAddressValidator } from "./address_validation";
import { reportUnexpectedAjaxError } from "./utils";


let originalAddressObj = {};
let recommendedAddressObj = {};

$(document).ready(function () {

    // this code applies to the order form pages
    if ($('.order-form').length === 0) {
        return;
    }

    const googleAddressValidator = new GoogleAddressValidator({});

    const $address = $('#place_autocomplete');
    const addressAutoComplete = makeAddressAutocomplete($address[0]);
    $address.keydown(event => {
        // Prevent the user selecting an address with the enter key from submitting the form
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    });

    const $loginForm = $('#login-form');
    const validator = $loginForm.validate({
        rules: {
            // company_code:  {
            //     required: true,
            // },
            company: {
                required: true
            },
            site: {
                required: true
            },
            first_name: {
                required: true,
            },
            last_name: {
                required: true,
            },
            email: {
                required: true,
                email: true,
            },
            address1: {
                required: true,
            },
            address2: {
                requiredIfSubpremise: true
            },
            city: {
                required: true,
            },
            state: {
                required: true,
            },
            zipcode: {
                required: true,
            },
            shoe_type: {
                required: true,
            },
            shoe_size: {
                required: true,
            }
        },
        messages: {
            // company_code: {
            //     required: pgettext('field error', 'Please enter company code')
            // },
            company: {
                required: pgettext('field error', 'Please select your company')
            },
            site: {
                required: pgettext('field error', 'Please select your site')
            },
            first_name: {
                required: pgettext('field error', 'Please enter your first name')
            },
            last_name: {
                required: pgettext('field error', 'Please enter your last name')
            },
            email: {
                required: pgettext('field error', 'Please enter a valid email address')
            },
            address1: {
                required: pgettext('field error', 'Please enter your address')
            },
            address2: {
                required: pgettext('field error', 'Apartment, suite, or unit # needed')
            },
            city: {
                required: pgettext('field error', 'Please enter your city')
            },
            state: {
                required: pgettext('field error', 'Please enter your state')
            },
            zipcode: {
                required: pgettext('field error', 'Please enter your zip code')
            },
            shoe_type: {
                required: pgettext('field error', 'Please select shoe type')
            },
            shoe_size: {
                required: pgettext('field error', 'Please select shoe size')
            }
        }
    });

    function shownInputsValid() {
        let allValid = true;

        // validator.elements() only returns elements which are visible
        for (const el of validator.elements()) {
            if (!validator.element(el)) {
                allValid = false;
            }
        }

        return allValid;
    }

    $.validator.addMethod("requiredIfSubpremise", function (value, element) {
        return !$(element).data('subpremise-required') || value.trim().length > 0;
    }, pgettext('field error', 'Apartment, suite, or unit # needed'));

    $loginForm.submit(event => {
        // Revalidate all shown inputs
        validator.form();
        if (!shownInputsValid()) {
            event.preventDefault();
            return false;
        }

        // All fields are valid, either submit the form or go to the next page

        const $step = $('.form-step-active');
        if ($step.hasClass('final-step')) {
            // We are on the last page, allow the submit to go through
            return;
        }

        // We are NOT on the last page; click the next button and block the submission
        event.preventDefault();
        $step.find('.btn-next').click();
        return false;
    });

    addressAutoComplete.addListener('place_changed', e => {
        // Force revalidation of the address field
        const addressValid = validator.element($address);
        if (!addressValid) {
            return;
        }

        const place = new GooglePlaceDetails(addressAutoComplete.getPlace());

        $('#address1').val(place.getStreetAddress())
        $('#address2').val('')
        $('#city_form').val(place.getCity())
        $('#state_form').val(place.getStateCode())
        $('#zipcode').val(place.getZipCode())
        $('#country_code').val(place.getCountryCode())

        const formattedAddress = formatAddressForAPI(
            place.getStreetAddress(),
            place.getCity(),
            place.getStateCode(),
            place.getZipCode()
        );

        googleAddressValidator.validateAddress(formattedAddress, getAddressValidationOptions()).then(response => {
            if (response.suggestedAction === 'ADD_SUBPREMISES') {
                $('#address2').data('subpremise-required', true);
                validator.element('#address2');
                $('#address2').addClass('error');
            } else {
                $('#address2').data('subpremise-required', false);
                validator.element('#address2');
                $('#address2').attr('placeholder', pgettext('field error', 'e.g. apartment, suite, unit, etc.'));
                $('#address2').removeClass('error');
            }
        }).catch(error => {
            console.error('Validation error:', error);
        });
    });

    // Setup company/site search
    const $company = $('#company');
    const $site = $('#site');
    const $siteError = $('#site_ajax_error');
    const $qrCodeFieldWrapper = $('#qr_code_field_wrapper');
    const companySearchURL = $('#companySearchURL').val();
    const companyInfoURL = $('#companyInfoURL').val();
    const validateSiteURL = $('#siteValidateURL').val();

    $company.select2({
        width: '100%',
        minimumInputLength: 3,
        ajax: {
            url: companySearchURL,
            dataType: 'json',
            delay: 250,
            processResults: data => {
                data = data.map(item => ({
                    id: item.prefix_code,
                    text: item.name
                }));
                return { results: data };
            },
            data: params => ({ search: params.term }),
            cache: true,
        }
    });
    // Move hidden select to before the newly created select2 so the error messages appear on the bottom
    $company.appendTo($company.parent());

    function setSiteOptions(options) {
        const $placeholder = $site.find('option[value=""]');

        // clear old options
        $site.find('option').not($placeholder).remove();
        $placeholder.prop('selected', true);

        if (options === null) {
            $site.prop('disabled', true);
        } else {
            options.forEach(opt => {
                $site.append(
                    $(`<option value="${opt.token}">${opt.name}</option>`)
                        .data('countryCode', opt.country_code)
                );
            });
            $site.prop('disabled', false);
        }

        $site.blur(); // Force revalidation
    }

    // The site's own country is a far more reliable source for address validation's
    // regionCode than Google Places autocomplete: it's known as soon as a site is
    // selected (including via the QR-link auto-select below), whereas autocomplete
    // can be bypassed entirely if the customer just types their address by hand (see
    // the "make country code optional" comment in order/forms.py). If the customer
    // does use autocomplete, its place_changed handler runs later and overrides this
    // with the address's actual detected country.
    $site.on('change', () => {
        const countryCode = $site.find('option:selected').data('countryCode');
        if (countryCode) {
            $('#country_code').val(countryCode);
        }
    });

    // Selecting a new option programmatically (rather than through select2's own search
    // UI) can cause select2 to fire a second, redundant native 'change' event once it
    // finishes syncing its internal state to the DOM mutation. Track the company info
    // we've already loaded so that redundant event -- for the same value -- is a no-op
    // instead of re-running setSiteOptions() and wiping out a site that was just selected.
    let companyInfoLoadedFor = null;

    $company.change(e => {
        $company.blur(); // Force revalidation

        const companyPrefixCode = $company.val();

        if (!companyPrefixCode) {
            companyInfoLoadedFor = null;
            setSiteOptions(null);
            $qrCodeFieldWrapper.addClass('d-none');
            return;
        }

        if (companyPrefixCode === companyInfoLoadedFor) {
            return;
        }
        companyInfoLoadedFor = companyPrefixCode;

        // Load the info for the selected company
        const req = $.ajax({
            method: 'GET',
            url: companyInfoURL.replaceAll('$company$', companyPrefixCode),
            success: function (data) {
                // Replace the option's placeholder label (its prefix code, used when the
                // company was pre-selected from a URL param) with the real company name.
                // select2 renders its own visible label into a separate element (with an
                // id derived from the <select>'s own id) rather than reading the <option>
                // live, so that has to be updated directly too.
                if (data.name) {
                    $company.find('option:selected').text(data.name);
                    $('#select2-' + $company.attr('id') + '-container')
                        .text(data.name).attr('title', data.name);
                }

                // The URL's ?company= value may have resolved via CompanyInfoView's
                // name fallback rather than an exact prefix_code match (e.g. an external
                // QR-generation tool using "amazon" instead of the real prefix code).
                // Swap the option's value to the real prefix_code, or the form would
                // submit an invalid company value that fails validation.
                if (data.prefix_code && data.prefix_code !== companyPrefixCode) {
                    $company.find('option:selected').val(data.prefix_code);
                    companyInfoLoadedFor = data.prefix_code;
                }

                setSiteOptions(data.sites);
                setAvailableInsoleModels(data.insole_models);

                // Only show the QR code field for companies that actually use it --
                // it's meaningless (and confusing) for every other company's order form.
                $qrCodeFieldWrapper.toggleClass('d-none', !data.qr_code_redemption_enabled);

                // Let anyone waiting on this company's site list (e.g. auto-selecting a
                // site from a URL param) know it's ready.
                $company.trigger('order_form:sitesLoaded', [data.sites]);
            },
            error: function (resp) {
                reportUnexpectedAjaxError(resp, 'loading sites');
                companyInfoLoadedFor = null; // allow a retry on re-selection
                setSiteOptions(null);
                setAvailableInsoleModels([]);
                $qrCodeFieldWrapper.addClass('d-none');
            }
        });
    });

    // Auto-select company/site from URL params, so an employee arriving via a QR code
    // link doesn't have to search for their own company. Expected URL shape:
    //   /order?company=<prefix code or name>&site=<Site.code>&access_code=<QR redemption code>
    // ("access_code" is handled server-side, pre-filling the qr_code_entered field below).
    // "company" is matched against Company.prefix_code first, then falls back to a
    // case-insensitive match on Company.name (see CompanyInfoView) since an external
    // QR-generation tool may use a human-friendly name instead of the internal code.
    // An unrecognized company or site is not an error -- the employee still sees the
    // normal search box / dropdown and can pick manually.
    (function autoSelectCompanyAndSiteFromURL() {
        const params = new URLSearchParams(window.location.search);
        const companyPrefixCode = params.get('company');
        const siteCode = params.get('site');

        if (!companyPrefixCode) {
            return;
        }

        if (siteCode) {
            $company.one('order_form:sitesLoaded', (e, sites) => {
                const match = sites.find(site => site.code === siteCode);
                if (match) {
                    $site.val(match.token).trigger('change');
                    $site.blur(); // Force revalidation
                }
            });
        }

        // Select2 needs a matching <option> to exist before it can select a value that
        // didn't come from its own search results. Its label is a placeholder until the
        // $company.change() handler above replaces it with the real company name.
        const $option = $('<option>').val(companyPrefixCode).text(companyPrefixCode).prop('selected', true);
        $company.append($option).trigger('change');
    })();

    //Order Form Steps Logic
    const prevBtns = document.querySelectorAll('.btn-prev');
    const nextBtns = document.querySelectorAll('.btn-next');
    const formSteps = document.querySelectorAll('.form-step');

    let formStepsNum = 0;
    nextBtns.forEach((btn) => {
        btn.addEventListener('click', () => {

            // remove all red borders
            $('input.error').removeClass('error');
            $('select.error').removeClass('error');

            if (formStepsNum === 0) {
                // check validity of all fields on this screen
                // const company_code_filled = validator.element('#company_code');
                const company_valid = validator.element($company);
                const site_valid = validator.element($site);
                const address_valid = validator.element('#place_autocomplete');
                const first_name_valid = validator.element('#first_name');
                const last_name_valid = validator.element('#last_name');
                const email_valid = validator.element('#email');

                // if (!company_code_filled) {
                //     $('#company_code').addClass('error');
                // }
                if (!company_valid) {
                    $company.addClass('error');
                }
                if (!site_valid) {
                    $site.addClass('error');
                }
                if (!address_valid) {
                    $address.addClass('error');
                }
                if (!first_name_valid) {
                    $('#first_name').addClass('error');
                }
                if (!last_name_valid) {
                    $('#last_name').addClass('error');
                }
                if (!email_valid) {
                    $('#email').addClass('error');
                }

                // only continue if all fields are valid
                if (shownInputsValid()) {

                    // extra step to validate the company/site on the backend

                    // show progress cursor and disable next button during this step
                    $('body').css('cursor', 'progress');
                    $('.btn-next').addClass('disabled');

                    // remove ajax error message
                    $siteError.hide();
                    // $('#company_code_ajax_error').hide();

                    // do the ajax call
                    $.ajax({
                        url: validateSiteURL,
                        method: 'POST',
                        data: {
                            company: $company.val(),
                            site: $site.val()
                        },
                        success: function (data) {
                            // if it is valid, move to the next step
                            moveToNextStep();
                            return;
                        },
                        error: function (data) {
                            // invalid results return 400 with a message
                            $siteError.text(data.responseJSON.message).show();
                            $site.addClass('error');
                        },
                        complete: function () {
                            // re-enable next button and restore cursor
                            $('body').css('cursor', 'default');
                            $('.btn-next').removeClass('disabled');
                        }
                    });
                }

            }
            if (formStepsNum === 1) {
                // check validity of all fields on this screen
                const address_valid = validator.element('#address1');
                const address2_valid = $('#address2').data('subpremise-required') ? validator.element('#address2') : true;
                const city_form_valid = validator.element('#city_form');
                const state_valid = validator.element('#state_form');
                const zip_valid = validator.element('#zipcode');

                if (!address_valid) {
                    $('#address1').addClass('error');
                }
                if (!address2_valid) {
                    $('#address2').addClass('error');
                }
                if (!city_form_valid) {
                    $('#city_form').addClass('error');
                }
                if (!state_valid) {
                    $('#state_form').addClass('error');
                }
                if (!zip_valid) {
                    $('#zipcode').addClass('error');
                }

                const formattedAddress = formatAddressForAPI(
                    $('#address1').val(),
                    $('#address2').val(),
                    $('#city_form').val(),
                    $('#state_form').val(),
                    $('#zipcode').val()
                );

                // continue if all fields are good
                if (address_valid && address2_valid && city_form_valid && state_valid && zip_valid) {
                    $('body').css('cursor', 'progress');
                    $('.btn-next').addClass('disabled');

                    originalAddressObj = {
                        address1: $('#address1').val(),
                        address2: $('#address2').val(),
                        city: $('#city_form').val(),
                        state: $('#state_form').val(),
                        zipCode: $('#zipcode').val(),
                        fullAddress: formattedAddress
                    };

                    // validate the address using the Google Address Validation API
                    googleAddressValidator.validateAddress(formattedAddress, getAddressValidationOptions()).then(response => {
                        if (response.postalAddress) {
                            // // Store the recommended address from Google
                            recommendedAddressObj = {
                                address1: response.postalAddress.addressLines.join(', '),
                                address2: response.postalAddress.subpremise,
                                city: response.postalAddress.locality,
                                state: response.postalAddress.administrativeArea,
                                zipCode: response.postalAddress.postalCode,
                                fullAddress: response.formattedAddress
                            };

                        }
                        // Always show the confirm-address step so the customer can accept
                        // Google's suggestion or keep what they typed. Previously this only
                        // advanced for ACCEPT/CONFIRM, so any other verdict (FIX,
                        // ADD_SUBPREMISES) -- even for a legitimate address Google just wasn't
                        // fully confident about -- left the Next button looking broken, with
                        // no error and no way forward.
                        updateAddressVerificationUI();
                        moveToNextStep();
                        return;
                    }).catch(error => {
                        console.error('Validation error:', error);
                    });

                    $('body').css('cursor', 'default');
                    $('.btn-next').removeClass('disabled');

                }
            }

            if (formStepsNum === 2) {
                // Store which address option was selected
                const selectedAddressOption = $('input[name="addressOption"]:checked').val();

                if (selectedAddressOption === 'recommended') {
                    // If using recommended address, update the form fields with the recommended values
                    $('#address1').val(recommendedAddressObj.address1).change();
                    $('#address2').val(recommendedAddressObj.address2).change();
                    $('#city_form').val(recommendedAddressObj.city).change();
                    $('#state_form').val(recommendedAddressObj.state).change();
                    $('#zipcode').val(recommendedAddressObj.zipCode).change();
                } else {
                    // If using original address, update the form fields with the original values
                    $('#address1').val(originalAddressObj.address1).change();
                    $('#address2').val(originalAddressObj.address2).change();
                    $('#city_form').val(originalAddressObj.city).change();
                    $('#state_form').val(originalAddressObj.state).change();
                    $('#zipcode').val(originalAddressObj.zipCode).change();
                }
                moveToNextStep();
                return;
            }
            if (formStepsNum === 3) {
                // check validity of all fields on this screen
                const shoe_type_valid = validator.element('#shoe_type');
                const shoe_size_valid = validator.element('#shoe_size');

                if (!shoe_type_valid) {
                    $('#shoe_type').addClass('error');
                }
                if (!shoe_size_valid) {
                    $('#shoe_size').addClass('error');
                }

                // continue if all fields are good
                if (shoe_type_valid && shoe_size_valid) {
                    moveToNextStep();
                    return;
                }
            }


        });
    });

    function moveToNextStep() {
        formStepsNum++;
        updateFormSteps();
    }

    prevBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            formStepsNum--;
            updateFormSteps();
        });
    });

    function updateFormSteps() {
        formSteps.forEach((formStep) => {
            formStep.classList.contains('form-step-active') &&
                formStep.classList.remove('form-step-active');
        });

        const $page = $(formSteps[formStepsNum]);
        $page.addClass('form-step-active');
        // Focus the first input element on the page which is not readonly
        $page.find('input:not([readonly]):first').focus();

        // show / hide different banner on the last step
        if (formStepsNum <= 2) {
            $('.welcome-header').show();
        } else {
            $('.welcome-header').hide();
        }
    }

    function getAddressValidationOptions() {
        // Google Places autocomplete fills #country_code from the selected address's
        // real country (see the place_changed listener above). USPS CASS validation
        // only supports 'US'/'PR' region codes and errors out for anything else, so
        // only enable it when the address is actually American; an empty country_code
        // (address typed manually, bypassing autocomplete) keeps the historical US default.
        const countryCode = ($('#country_code').val() || '').toUpperCase();
        return {
            regionCode: countryCode || undefined,
            enableUspsCass: countryCode === '' || countryCode === 'US'
        };
    }

    function formatAddressForAPI(address1, address2, city, state, zip) {
        let formattedAddress = address1.trim();

        // Add address2 if it exists
        if (address2 && address2.trim() !== '') {
            formattedAddress += ', ' + address2.trim();
        }

        formattedAddress += ', ' + city.trim();

        if (state && state.trim() !== '') {
            formattedAddress += ', ' + state.trim();
        }

        if (zip && zip.trim() !== '') {
            formattedAddress += ' ' + zip.trim();
        }

        return formattedAddress;
    }

    function updateAddressVerificationUI() {
        const $originalAddressText = $('.original-address-text');
        const $recommendedAddressText = $('.recommended-address-text');

        const originalAddressFormatted = formatAddressForDisplay(originalAddressObj);
        const recommendedAddressFormatted = formatAddressForDisplay(recommendedAddressObj);

        $originalAddressText.html(originalAddressFormatted);
        $recommendedAddressText.html(recommendedAddressFormatted);
    }

    // Helper function to format address for display
    function formatAddressForDisplay(addressObj) {
        if (!addressObj || Object.keys(addressObj).length === 0) {
            return 'No address available';
        }
        const lines = [];

        // Line 1: Street address
        lines.push(addressObj.address1);

        // Line 2: Address2 (if available)
        if (addressObj.address2) {
            lines.push(addressObj.address2);
        }

        // Line 2: City, State ZIP
        lines.push(`${addressObj.city}, ${addressObj.state} ${addressObj.zipCode}`);

        return lines.map(line => `<div>${line}</div>`).join('');
    }


    function updateAddressSelection() {
        $('.address-option').removeClass('border-primary');
        // Add highlight to the selected address option
        $('input[name="addressOption"]:checked').closest('.address-option').addClass('border-primary');
        // Log the value of the selected address option
        const selectedValue = $('input[name="addressOption"]:checked').val();
        return selectedValue;
    }

    $(document).on('change', 'input[name="addressOption"]', function () {
        const selecedAddressOption = updateAddressSelection();
    });

    // Make the entire address box clickable
    $(document).on('click', '.address-option', function (e) {
        if (!$(e.target).is('input[type="radio"]')) {
            const radioButton = $(this).find('input[type="radio"]');
            radioButton.prop('checked', true).trigger('change');
        }
    });


    // On change of input elements update Step 3 confirmation screen
    $('.user_change').change(function () {
        const changed_field = $(this).attr('name');
        let changed_field_val = $(this).val();
        if (this.tagName === 'SELECT') {
            // Use the display value for select fields
            changed_field_val = $(this).find('option:selected').text().trim();
        }
        $('#summary_' + changed_field).text(changed_field_val);

        // toggle the optional address2 field
        if (changed_field === 'address2') {
            if (changed_field_val) {
                $('#summary_' + changed_field).show();
            } else {
                $('#summary_' + changed_field).hide();
            }
        }
    });

    // Setup insole options
    const $insole_model_section = $('.insole-model-section');
    const $insole_models = $('[name="insole_model"]');
    const $shoe_type = $('#shoe_type');
    const $shoe_size = $('#shoe_size');

    function setAvailableInsoleModels(models) {
        // Hide/disable all models. We will un-hide the relevant ones next
        $insole_models.prop({
            disabled: true,
            checked: false
        }).parent('.opt-container').hide();

        // Now show/enable any available models
        models.forEach(model_name => {
            $insole_models.filter(`[value="${model_name}"]`).prop(
                'disabled', false
            ).parent('.opt-container').show();
        });

        if (models.length > 1) {
            // Only show model selection if more than 1 model is available
            $insole_model_section.show();
        } else {
            // Auto select the first available model and hide the radio buttons
            $insole_model_section.hide();
            $insole_models.filter(':not(:disabled):first').prop('checked', true);
        }

        // trigger change handlers
        $insole_models.first().change();
    }

    function getSelectedInsoleModel() {
        const $selected_model = $insole_models.filter(':checked');
        return $selected_model.length ? $selected_model.val() : null;
    }

    $insole_models.change(e => {
        const insole_model = getSelectedInsoleModel();

        if (!insole_model) {
            // If no model is selected, disabled the type dropdown
            $shoe_type.prop('disabled', true).val('').change();
            return;
        }

        // At this point we know an insole model has been selected

        // Update summary page
        $('#summary_insole_model').text(insole_model);

        // store the selected shoe type before its cleared
        const selected_shoe_type = $shoe_type.val();
        $shoe_type.val('');
        $shoe_type.prop('disabled', false);

        // Hide/disable all options. We will un-hide the relevant ones next
        $shoe_type.find('option').prop({
            hidden: true,
            disabled: true
        });

        // un-hide the type options associated with the selected model
        const available_types = Object.keys(
            SHOE_SIZES_BY_MODEL_AND_TYPE[insole_model] || {}
        );
        available_types.forEach(shoe_type => {
            $shoe_type.find(`option[value="${shoe_type}"]`).prop({
                hidden: false,
                disabled: false,
                selected: selected_shoe_type === shoe_type
            });
        });

        $shoe_type.change();
    });

    $shoe_type.change(function () {
        // get the shoe type
        const insole_model = getSelectedInsoleModel();
        const shoe_type = $(this).val();

        // get the current shoe size
        const selected_shoe_size = $shoe_size.val();

        // clear the selected size
        $shoe_size.val('');

        // Hide/disable all options. We will un-hide the relevant ones next
        $shoe_size.find('option').prop({
            hidden: true,
            disabled: true
        });

        if (!insole_model || !shoe_type) {
            // If no model or shoe type is selected, disable the shoe size drop down
            $shoe_size.addClass('disabled');
            $shoe_size.prop('disabled', true);
        } else {
            // with a model and shoe type selected, enable the shoe size drop down
            $shoe_size.removeClass('disabled');
            $shoe_size.prop('disabled', false);

            // un-hide the size options that go with the model and shoe type
            SHOE_SIZES_BY_MODEL_AND_TYPE[insole_model][shoe_type].forEach(item => {
                $shoe_size.find(`option[value="${item}"]`).prop({
                    hidden: false,
                    disabled: false,
                    selected: item === selected_shoe_size
                });
            });
        }

        $shoe_size.change();
    });

    // Set no available models to start, they will be populated once the user selects a company
    setAvailableInsoleModels([]);

    // on page load make sure all summary fields are updated
    $('.user_change').change();

});
